<script>
  import HeaderBarBrand from './HeaderBarBrand.svelte';
</script>

<header>
  <nav
    class="navbar has-background-dark is-dark"
    aria-label="main navigation">
    <HeaderBarBrand />
  </nav>
</header>
